import { combineReducers } from 'redux';
import { gearSlice } from '~/pages/ItemSaga/Gear/gearSlice';
import { artifactSlice } from '~/pages/ItemSaga/Artifact/artifactSlice';
import { heroSkinSlice } from '~/pages/ItemSaga/HeroSkin/heroSkinSlice';
import { diceSkinSlice } from '~/pages/ItemSaga/DiceSkin/diceSkinSlice';
import { cardSkinSlice } from '~/pages/ItemSaga/CardSkin/cardSkinSlice';
import { emoteSlice } from '~/pages/ItemSaga/Emote/emoteSlice';
import { rewardSlice } from '~/pages/ItemSaga/Reward/rewardSlice';
import { playerIconSlice } from '~/pages/ItemSaga/PlayerIcon/playerIconSlice';
import { exchangeSlice } from '~/pages/ShopSaga/Exchange/exchangeSlice';
import { lootBoxSlice } from '~/pages/ItemSaga/LootBox/lootBoxSlice';
import { itemSlice } from '~/pages/ItemSaga/Item/itemSlice';
import { consumableSlice } from '~/pages/ItemSaga/Consumable/consumableSlice';
import { swapEffectSlice } from '~/pages/ItemSaga/SwapEffect/swapEffectSlice';

export const itemSagaReducers = combineReducers({
    gear: gearSlice.reducer,
    artifact: artifactSlice.reducer,
    heroSkin: heroSkinSlice.reducer,
    diceSkin: diceSkinSlice.reducer,
    cardSkin: cardSkinSlice.reducer,
    exchange: exchangeSlice.reducer,
    emote: emoteSlice.reducer,
    playerIcon: playerIconSlice.reducer,
    reward: rewardSlice.reducer,
    lootBox: lootBoxSlice.reducer,
    item: itemSlice.reducer,
    consumable: consumableSlice.reducer,
    swapEffect: swapEffectSlice.reducer,
});
